// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/common/AreaCard.scss
// module id = 1298
// module chunks = 0